export default [
    {
        'id': 1,
        'handle': 'frontend',
        'title': 'Frontend',
        'color': 'green darken-1'
    },
    {
        'id': 2,
        'handle': 'backend',
        'title': 'Backend',
        'color': 'blue-grey darken-1'
    },
    {
        'id': 3,
        'handle': 'api',
        'title': 'API',
        'color': 'red'
    },
    {
        'id': 4,
        'handle': 'issue',
        'title': 'Issue',
        'color': 'blue'
    },
    {
        'id': 5,
        'handle': 'mobile',
        'title': 'Mobile',
        'color': 'orange'
    }
];


// WEBPACK FOOTER //
// ./app/routes/todo/data/labels.js